import { US_MAJOR_SCOPE, US_MAJOR_CFL_SCOPE, ALLOWED_LEAGUE_SCOPES } from "./nflLeagueScope";

const STORAGE_KEY = "nflLeagueScope";

export function readStoredLeagueScope() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw && ALLOWED_LEAGUE_SCOPES.includes(raw)) return raw;
  } catch {
    // ignore storage errors
  }
  return US_MAJOR_SCOPE;
}

export function writeStoredLeagueScope(scope) {
  try {
    localStorage.setItem(STORAGE_KEY, scope);
  } catch {
    // ignore storage errors
  }
}

export function parseIncludeCflParam(searchParams) {
  const raw = searchParams.get("includeCfl");
  if (raw === null) return null;
  if (raw === "1" || raw === "true") return US_MAJOR_CFL_SCOPE;
  if (raw === "0" || raw === "false") return US_MAJOR_SCOPE;
  return null;
}

export function appendIncludeCflToSearchParams(params, scope) {
  if (scope === US_MAJOR_CFL_SCOPE) {
    params.set("includeCfl", "1");
  } else {
    params.delete("includeCfl");
  }
}
